const colors = ['#ffd27a', '#ff6b81', '#4ecdc4', '#845ec2', '#fff173', '#6bc5ff']

type Particle = {
  x: number
  y: number
  vx: number
  vy: number
  width: number
  height: number
  color: string
  rotation: number
  spin: number
}

export function playConfetti(options: {
  particleCount?: number
  durationMs?: number
}) {
  const { particleCount = 160, durationMs = 3500 } = options
  // confetti is real motion, so unlike the glow fade it must be skipped entirely
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  const canvas = document.createElement('canvas')
  canvas.setAttribute('aria-hidden', 'true')
  // above the sheep run overlay (z-index 10001), otherwise a win celebrates
  // behind the game
  canvas.style.cssText =
    'position:fixed;inset:0;z-index:10002;pointer-events:none;width:100%;height:100%'
  const context = canvas.getContext('2d')
  if (!context) return

  const dpr = window.devicePixelRatio || 1
  const width = window.innerWidth
  const height = window.innerHeight
  canvas.width = width * dpr
  canvas.height = height * dpr
  context.scale(dpr, dpr)
  document.body.appendChild(canvas)

  // two "party poppers", firing up and inwards from the bottom corners
  const particles: Particle[] = []
  for (let i = 0; i < particleCount; i++) {
    const fromLeft = i % 2 === 0
    const angleDeg = (fromLeft ? -60 : -120) + (Math.random() - 0.5) * 50
    const angle = (angleDeg * Math.PI) / 180
    const speed = 9 + Math.random() * 13
    particles.push({
      x: fromLeft ? -10 : width + 10,
      y: height * (0.6 + Math.random() * 0.3),
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      width: 6 + Math.random() * 4,
      height: 3 + Math.random() * 3,
      color: colors[i % colors.length] ?? '#ffd27a',
      rotation: Math.random() * Math.PI,
      spin: (Math.random() - 0.5) * 0.3
    })
  }

  const startedAt = performance.now()
  const fadeMs = 500

  const frame = (now: number) => {
    const elapsed = now - startedAt
    if (elapsed >= durationMs) {
      canvas.remove()
      return
    }

    context.clearRect(0, 0, width, height)
    context.globalAlpha =
      elapsed > durationMs - fadeMs ? (durationMs - elapsed) / fadeMs : 1

    for (const particle of particles) {
      particle.vy += 0.25
      particle.vx *= 0.99
      particle.vy *= 0.99
      particle.x += particle.vx
      particle.y += particle.vy
      particle.rotation += particle.spin

      context.save()
      context.translate(particle.x, particle.y)
      context.rotate(particle.rotation)
      context.fillStyle = particle.color
      context.fillRect(
        -particle.width / 2,
        -particle.height / 2,
        particle.width,
        particle.height
      )
      context.restore()
    }

    requestAnimationFrame(frame)
  }
  requestAnimationFrame(frame)

  // rAF pauses in hidden tabs - make sure the canvas never lingers
  setTimeout(() => canvas.remove(), durationMs + 4000)
}
